module.exports = "//static.hsappstatic.net/ui-addon-avatars/static-2.7654/images/default-avatar.png"